/**
 * Apple Pay on the Web：与 ApplePaySession 构造函数兼容的 API version 号。
 * 逻辑与 CardElements/MyApplePayButton 对齐，供收银台等非 iframe 场景复用。
 */
function getIOSVersion() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const iosVersion =
    /iPad|iPhone|iPod/.test(userAgent) && userAgent.match(/(\d+)_(\d+)_?(\d+)?/);
  if (iosVersion) {
    const version1 = iosVersion[0]?.replace(/_/, '.');
    return version1?.replace(/_/, '');
  }
}

function getMacOSVersion() {
  const userAgent = navigator.userAgent;
  const macOSVersionRegex = /Mac OS X ([0-9_]+)/;
  const matches = userAgent.match(macOSVersionRegex);
  if (matches && matches.length > 1) {
    const x = matches[1]?.replace(/_/, '.');
    return x?.replace(/_/, '');
  }
}

export function getApplePaySessionApiVersion() {
  const IOS_VERSION = Number(getIOSVersion());
  const MAC_VERSION = Number(getMacOSVersion());
  let version = '';
  if (IOS_VERSION >= 16 || MAC_VERSION >= 13) {
    version = 14;
  } else if (
    (IOS_VERSION >= 15.4 && IOS_VERSION < 16) ||
    (MAC_VERSION >= 12.3 && MAC_VERSION < 13)
  ) {
    version = 13;
  } else if (
    (IOS_VERSION >= 15 && IOS_VERSION < 15.4) ||
    (MAC_VERSION >= 12 && MAC_VERSION < 12.3)
  ) {
    version = 12;
  } else if (
    (IOS_VERSION >= 14.5 && IOS_VERSION < 15) ||
    (MAC_VERSION >= 11.5 && MAC_VERSION < 12)
  ) {
    version = 11;
  } else if (
    (IOS_VERSION >= 14 && IOS_VERSION < 14.5) ||
    (MAC_VERSION >= 11 && MAC_VERSION < 11.5)
  ) {
    version = 10;
  } else if (
    (IOS_VERSION >= 13.6 && IOS_VERSION < 14) ||
    (MAC_VERSION >= 10.156 && MAC_VERSION < 11)
  ) {
    version = 9;
  } else if (
    (IOS_VERSION >= 13.2 && IOS_VERSION < 13.6) ||
    (MAC_VERSION >= 10.151 && MAC_VERSION < 10.156)
  ) {
    version = 8;
  } else if (
    (IOS_VERSION >= 12.4 && IOS_VERSION < 13.2) ||
    (MAC_VERSION >= 10.146 && MAC_VERSION < 10.151)
  ) {
    version = 7;
  } else if (
    (IOS_VERSION >= 12.2 && IOS_VERSION < 12.4) ||
    (MAC_VERSION >= 10.144 && MAC_VERSION < 10.146)
  ) {
    version = 6;
  } else if (
    (IOS_VERSION >= 12.11 && IOS_VERSION < 12.2) ||
    (MAC_VERSION >= 10.142 && MAC_VERSION < 10.144)
  ) {
    version = 5;
  } else if (
    (IOS_VERSION >= 12.1 && IOS_VERSION < 12.11) ||
    (MAC_VERSION >= 10.141 && MAC_VERSION < 10.142)
  ) {
    version = 4;
  } else if (
    (IOS_VERSION >= 11 && IOS_VERSION < 12.1) ||
    (MAC_VERSION >= 10.13 && MAC_VERSION < 10.141)
  ) {
    version = 3;
  } else if (
    (IOS_VERSION >= 10.1 && IOS_VERSION < 11) ||
    (MAC_VERSION >= 10.121 && MAC_VERSION < 10.13)
  ) {
    version = 2;
  } else if (
    (IOS_VERSION >= 10 && IOS_VERSION < 10.1) ||
    (MAC_VERSION >= 10.12 && MAC_VERSION < 10.121)
  ) {
    version = 1;
  }
  return version || 6;
}
